import { Crf20222025 } from './Crf20222025';
import { Crf20262029 } from './Crf20262029';
import { CrfVersion } from './CrfVersion';
import { LegacyCrf } from './LegacyCrf';

const crf20222025 = new Crf20222025();
const crf20262029 = new Crf20262029();
const legacy = new LegacyCrf();

const REGISTRY: Record<string, CrfVersion> = {
  [crf20222025.code]: crf20222025,
  [crf20262029.code]: crf20262029,
};

export function resolveCrf(code: string | null | undefined): CrfVersion {
  return (code && REGISTRY[code]) || legacy;
}
